<template>
  <div class="main-box">
    <!-- 教学实验课 -->
    <div class="search">
      <div class="leftcontain">
        <div class="left1">
          <div class="text">录像日期:</div>
          <el-date-picker v-model="allTime" type="daterange" range-separator="至" value-format="timestamp"
            start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </div>
      </div>
      <div class="rightcontain">
        <el-button type="primary" @click="search" style="background: #3d84ff">查询</el-button>
        <el-button type="info" @click="reset">重置</el-button>
      </div>
    </div>
    <div class="parentt">
      <div class="contain">
        <div class="contont-right">
          <div class="btn-select-left">
            <el-checkbox v-model="checkAll" :indeterminate="isIndeterminate" @change="handleCheckAllChange"
              v-if="videoList.length > 0">
              全选</el-checkbox>
          </div>
          <div class="plyer-list">
            <div v-for="(item, index) in videoList" :key="index" class="plyer-box">
              <div v-if="videoList" class="video-list">
                <div class="video-img" @click="videoclick(item)" style="cursor: pointer;">
                  <el-image style="width: 100%; height: 100%" :src="item.cover ? item.cover : img" fit="fill" />
                </div>
                <div class="video-time-size" style="display: block;text-align: center;">{{ item.name.split('.')[0] }}
                </div>
                <div class="video-time-size">
                  <div class="video-check">
                    <el-checkbox-group v-model="checked" @change="handleCheckChange">
                      <el-checkbox :key="item.id" :label="item.id"></el-checkbox>
                    </el-checkbox-group>
                  </div>
                  <div class="video-time">
                    <span>{{ item.start_time | formatTime }} -
                      {{ item.end_time | formatTime }}</span>
                  </div>
                  <div class="video-size">
                    <span>{{ item.size | changeType }}</span>
                  </div>
                </div>
              </div>
              <div v-else>
                <el-image style="width: 100%; height: 100%" :src="zw_data" fit="fill" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 实操回顾弹框 -->
    <operate-review :visible.sync="reviewVisible" ref="reviewChild" @updReview="updReview"></operate-review>

  </div>
</template>

<script>
import dayjs from "dayjs";
import { cameraPeriodList } from "@/api/courselibtimetable";
import operateReview from './components/operateReview.vue'
export default {
  components: { operateReview },
  name: "experimentProcessRecord",
  filters: {
    formatTime: function (value) {
      if (!value) return "";
      // return dayjs.unix(value).format("HH:mm:ss");
      return dayjs.unix(value).format("MM-DD HH:mm");
    },
    dataFormat: function (value) {
      if (!value) return "00:00:00";
      var seconds = parseInt(value, 10);
      var hours = Math.floor(seconds / 3600);
      var minutes = Math.floor((seconds - hours * 3600) / 60);
      var secondsRemain = seconds - hours * 3600 - minutes * 60;

      return hours
        ? (hours < 10 ? "0" + hours : hours) +
        ":" +
        (minutes < 10 ? "0" + minutes : minutes) +
        ":" +
        (secondsRemain < 10 ? "0" + secondsRemain : secondsRemain)
        : (minutes < 10 ? "0" + minutes : minutes) +
        ":" +
        (secondsRemain < 10 ? "0" + secondsRemain : secondsRemain);
    },
    changeType(val) {
      if (val == "0") return "0B";
      var k = 1024;
      var sizes = ["B", "KB", "MB", "GB", "TB"];
      const i = Math.floor(Math.log(val) / Math.log(k)); // 得出该数字的单位应该是kB?MB
      return (val / Math.pow(k, i)).toPrecision(3) + "" + sizes[i];
    },
  },
  data() {
    return {
      queryParams: {
        start_date: "",
        end_date: "",
        page: 1,
        per_page: 10,
      },
      allTime: null,
      img: require('@/assets/video_img.png'), // 默认视频封面图

      reviewVisible: false,//回顾弹框
      videoList: [], // 视频列表
      checked: [], // 批量选择下载
      video_url: {}, // 视频地址
      zw_data: require("@/assets/data.png"),
      checkAll: false,
      isIndeterminate: "",
      checkList: [], // 勾选的数据
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    reset() {
      this.queryParams = {
        start_date: "",
        end_date: "",
        page: 1,
        per_page: 10,
      };
      this.allTime = null;
      this.loadData();
    },
    search() {
      this.queryParams.page = 1;
      this.loadData();
    },
    loadData() {
      let start_date = "";
      let end_date = "";
      if (this.allTime && this.allTime.length) {
        start_date = Math.floor(this.allTime[0] / 1000);
        end_date = Math.floor(this.allTime[1] / 1000);
      }
      let params = {
        start_date: start_date,
        end_date: end_date,
        page: this.queryParams.page,
        per_page: this.queryParams.per_page,
      };
      console.log("加兹安数据", params);
      cameraPeriodList(params)
        .then((response) => {
          this.videoList = response.data.data;
        })
        .catch((error) => {
          //console.log(error)
        });
    },
    // 全选
    handleCheckAllChange(val) {
      if (val) {
        // 全选：将所有视频的id加入checked数组
        this.checked = this.videoList.map((item) => item.id);
        this.isIndeterminate = false;
        // 更新checkList为选中的视频对象
        this.checkList = JSON.parse(JSON.stringify(this.videoList));
      } else {
        // 取消全选
        this.checked = [];
        this.isIndeterminate = false;
        this.checkList = [];
      }
    },
    // 单选
    handleCheckChange() {
      // 更新checkList为选中的视频对象
      this.checkList = this.videoList.filter((item) =>
        this.checked.includes(item.id)
      );

      // 更新全选按钮状态
      if (this.checked.length === 0) {
        // 未选中任何项
        this.checkAll = false;
        this.isIndeterminate = false;
      } else if (this.checked.length === this.videoList.length) {
        // 选中所有项
        this.checkAll = true;
        this.isIndeterminate = false;
      } else {
        // 部分选中
        this.checkAll = false;
        this.isIndeterminate = true;
      }
    },
    videoclick(row) {
      this.$refs.reviewChild.loadObj(row)
      this.reviewVisible = true;
    },
    //关闭回顾弹框刷新
    updReview() {
      this.reviewVisible = false;
    },
  },
};
</script>
<style scoped lang="scss">
@media screen and (max-width: 640px) {
  .main-box {
    min-height: 400px;

    .search {
      padding-left: 10px;
      padding-right: 10px;
      background: #fcfcfc;
      background: #fff;
      padding-top: 15px;

      .leftcontain {
        .left1 {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-top: 15px;

          .text {
            margin-right: 10px;
            font-size: 15px;
            font-weight: 400;
            color: #666666;
          }

          .elinput {
            width: 80%;

            ::v-deep .el-input__inner {
              border-radius: 25px;
              border: 1px solid #3d84ff;
              height: 32px;
            }

            ::v-deep .el-input__suffix {
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }

          ::v-deep .el-date-editor {
            border-radius: 25px;
            border: 1px solid #3d84ff;
            height: 32px;
          }

          // ::v-deep .el-date-editor .el-input__inner {
          //   border-radius: 25px;
          //   border: 1px solid #3d84ff;
          //   height: 32px;
          // }
        }
      }

      .rightcontain {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin: 15px 0px;

        ::v-deep .el-button {
          border-radius: 25px;
          height: 32px;
          line-height: 32px;
          padding: 0 20px;
          font-size: 14px;
        }

        ::v-deep .el-button--primary {
          background: #3d84ff;
          border-color: #3d84ff;
          color: #ffffff;
        }

        ::v-deep .el-button--info {
          background: #ffffff;
          border: 1px solid #3d84ff;
          color: #3d84ff;
          margin-left: 10px;
        }
      }
    }

    .parentt {
      position: relative;

      .contain {
        position: absolute;
        top: 0px;
        left: 0px;
        right: 0px;

        .contont-right {
          width: calc(100% - 30px);
          background: #fff;
          min-height: 800px;

          .camer-p {
            background: #ccc;
            font-size: 18px;
            padding: 12px 0 12px 30px;
            color: rgb(88, 88, 235);
          }

          .btn-select-left {
            margin-top: 10px;
            width: calc(100% - 20px);
            float: left;
            margin-left: 10px;
          }

          .plyer-box {
            width: calc(100% / 3);
            float: left;

            .plyer-footer {
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 20px;

              span {
                font-size: 16px;
                color: rgb(87, 87, 168);
                cursor: pointer;
              }
            }

            .video-list {
              border: 1px solid #e8e8e8;
              margin: 10px;

              .video-time-size {
                display: flex;
                height: 40px;
                line-height: 40px;
                flex-wrap: nowrap;
                justify-content: space-between;
                padding: 0 15px;
                font-weight: bold;
                font-size: 14px;

                .video-time {
                  padding: 0 15px;
                }
              }
            }
          }

          .btn-select {
            margin-top: 10px;
            display: flex;
            flex-wrap: nowrap;
            justify-content: flex-end;
            margin-right: 10px;
          }
        }
      }
    }
  }
}

@media screen and (min-width: 1200px) {
  .main-box {
    .search {
      padding-left: 10px;
      padding-right: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 56px;
      background: #fcfcfc;
      background: #fff;

      .leftcontain {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .left1 {
          display: flex;
          justify-content: flex-start;
          align-items: center;

          .text {
            margin-right: 10px;
            font-size: 15px;
            font-weight: 400;
            color: #666666;
          }

          ::v-deep .el-input__inner {
            border-radius: 25px;
            border: 1px solid #3d84ff;
            height: 32px;
          }

          // .elinput {
          //   width: 200px;

          //   ::v-deep .el-input__inner {
          //     border-radius: 25px;
          //     border: 1px solid #3d84ff;
          //     height: 32px;
          //   }

          //   ::v-deep .el-input__suffix {
          //     display: flex;
          //     justify-content: center;
          //     align-items: center;
          //   }
          // }

          ::v-deep .el-date-editor .el-input__inner {
            border-radius: 25px;
            border: 1px solid #3d84ff;
            height: 32px;
          }

          ::v-deep .el-input__icon {
            line-height: 25px;
          }

          ::v-deep .el-range-separator {
            line-height: 25px;
          }
        }
      }

      .rightcontain {
        display: flex;
        justify-content: center;
        align-items: center;

        ::v-deep .el-button {
          border-radius: 25px;
          height: 32px;
          line-height: 32px;
          padding: 0 20px;
          font-size: 14px;
        }

        ::v-deep .el-button--primary {
          background: #3d84ff;
          border-color: #3d84ff;
          color: #ffffff;
        }

        ::v-deep .el-button--info {
          background: #ffffff;
          border: 1px solid #3d84ff;
          color: #3d84ff;
          margin-left: 10px;
        }
      }
    }

    .parentt {
      position: relative;

      .contain {
        position: absolute;
        top: 0px;
        left: 0px;
        right: 0px;

        .contont-right {
          width: calc(100% - 30px);
          background: #fff;
          min-height: 800px;

          .camer-p {
            background: #ccc;
            font-size: 18px;
            padding: 12px 0 12px 30px;
            color: rgb(88, 88, 235);
          }

          .btn-select-left {
            margin-top: 10px;
            width: calc(100% - 20px);
            float: left;
            margin-left: 10px;
          }

          .plyer-box {
            width: calc(100% / 3);
            float: left;

            .plyer-footer {
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 20px;

              span {
                font-size: 16px;
                color: rgb(87, 87, 168);
                cursor: pointer;
              }
            }

            .video-list {
              border: 1px solid #e8e8e8;
              margin: 10px;

              .video-time-size {
                display: flex;
                height: 40px;
                line-height: 40px;
                flex-wrap: nowrap;
                justify-content: space-between;
                padding: 0 15px;
                font-weight: bold;
                font-size: 14px;

                .video-time {
                  padding: 0 15px;
                }
              }
            }
          }

          .btn-select {
            margin-top: 10px;
            display: flex;
            flex-wrap: nowrap;
            justify-content: flex-end;
            margin-right: 10px;
          }
        }
      }
    }
  }
}
</style>
